/* WC TV — the tube, the playlist and the seeded video index.
 *
 * Extracted from sections/wc-tvtube.liquid on 2026-08-25. It was 32KB of inline script shipped on every
 * view of that page — parsed fresh each time, never cached, and counted against the HTML.
 *
 * Safe to move because it publishes NO globals and nothing else in the theme reaches into it.
 * Loaded with `defer`, which runs after the document is parsed and before DOMContentLoaded —
 * the same moment an end-of-body inline block ran, so every getElementById in here still finds
 * its element.
 *
 * ONE LIQUID VALUE became a data attribute: settings.social_youtube_link. A theme setting
 * cannot travel inside a cached asset, and reading it from the DOM is the only honest way to
 * keep the file static — the alternative is leaving 32KB inline for one URL.
 */
(function () {
  var SEEDS = {};
  try { SEEDS = (JSON.parse(document.getElementById('wc-tv-seeds').textContent) || {}).vids || {}; } catch (e) {}
  var REALYT = (document.getElementById('wc-tv-seeds') && document.getElementById('wc-tv-seeds').getAttribute('data-yt')) || '';
  function beacon(e){ try{navigator.sendBeacon('https://api.weirdcastle.com/api/signal',JSON.stringify({e:e}));}catch(x){} }
  function toast(m){ var t=document.getElementById('yt-toast'); t.textContent=m; t.classList.add('on'); clearTimeout(t._h); t._h=setTimeout(function(){t.classList.remove('on');},2800); }

  var v = document.getElementById('yt-video');
  var ttl = document.getElementById('yt-ftitle');
  var sts = document.getElementById('yt-fstats');
  var dsc = document.getElementById('yt-fdesc');
  var lks = document.getElementById('yt-likes');

  /* Which video is loaded in the player, by its counter id. Views and likes are counted
     PER VIDEO now (tv_v_<id> / tv_l_<id>), so the numbers on each card are that card's own
     record rather than set dressing. The pinned video names itself with data-vid on the
     <video> (the trailer it once was got deleted from Files), so the id lives next to the src. */
  var curVid = v.getAttribute('data-vid') || 'hero';
  function likedKey(id) { return 'wc-tv-liked-' + id; }
  function syncLike() {
    var on = false;
    try { on = localStorage.getItem(likedKey(curVid)) === '1'; } catch (e) {}
    document.getElementById('yt-like').classList.toggle('on', on);
  }
  syncLike();

  /* A view = the video actually started playing, counted once per load — not once per
     pause/resume, and not on card click (the click handler calls play(), which lands here). */
  v.addEventListener('play', function () {
    if (v._counted === v.currentSrc) return;
    v._counted = v.currentSrc;
    beacon('wctv_play');
    if (curVid) beacon('tv_v_' + curVid);
  });

  /* Josh: "clicking a video should open a real YouTube-style watch page." Cards navigate
     to ?v=<id>; the router below builds the watch view. */
  document.querySelectorAll('.yt-card[data-src]').forEach(function (c) {
    c.addEventListener('click', function () {
      var id = c.getAttribute('data-vid');
      if (id) location.href = '/pages/wc-tv?v=' + encodeURIComponent(id);
    });
  });

  /* SUBSCRIBE — a real button attached to a real number.
     The count rendered by Liquid is the true tally from wc_signals. Pressing this fires the
     same beacon every other counted event on this site uses, so the server number genuinely
     goes up and the next visitor sees it. The +1 here is optimistic local feedback for the
     press you just made, not a second source of truth — reload and you get the server's
     figure. Unsubscribing does NOT decrement: the beacon only counts presses, so pretending
     to take one back would put a number on screen the server does not have. */
  var sub = document.getElementById('yt-sub');
  var subn = document.getElementById('yt-subn');
  var SUBKEY = 'wc-tv-subscribed';
  try { if (localStorage.getItem(SUBKEY) === '1') { sub.classList.add('done'); sub.textContent = 'Subscribed \u2713'; } } catch (e) {}

  /* PEOPLE, NOT PRESSES (Josh): the counter moves once per device, ever (wc-tv-subcounted).
     Re-subscribing after an unsubscribe flips the button but not the number — same person. */
  var CNTKEY = 'wc-tv-subcounted';
  sub.addEventListener('click', function () {
    var on = sub.classList.toggle('done');
    sub.textContent = on ? 'Subscribed \u2713' : 'Subscribe';
    try { localStorage.setItem(SUBKEY, on ? '1' : '0'); } catch (e) {}
    if (!on) return;
    toast('Subscribed to Weirdcastle TV. The bell is always on. It cannot be turned off.');
    /* Josh: subscribing here should also open the real YouTube channel in a new tab —
       the parody button recruits for the actual channel. Only if one is configured. */
    if (REALYT) window.open(REALYT, '_blank', 'noopener');
    var counted = false;
    try { counted = localStorage.getItem(CNTKEY) === '1'; } catch (e) {}
    if (counted) return;
    try { localStorage.setItem(CNTKEY, '1'); } catch (e) {}
    if (subn) {
      var n = parseInt(subn.getAttribute('data-n') || '0', 10) + 1;
      subn.setAttribute('data-n', n);
      subn.textContent = n;
      /* Liquid pluralises on the server value; when JS moves the number mid-session it has
         to keep the word in step, or the first subscriber reads "1 subscribers". Replace the
         WORD only — this text node also carries the video count after it. */
      var word = subn.nextSibling;
      if (word && word.nodeType === 3) word.nodeValue = word.nodeValue.replace(/subscribers?/, n === 1 ? 'subscriber' : 'subscribers');
    }
    beacon('tv_subscribe');
  });

  /* TABS. Five real views over the sections that already exist, rather than five links back
     to this page. The hash keeps a tab linkable and survives a refresh. */
  (function () {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.yt-tabs a[data-view]'));
    var secs = Array.prototype.slice.call(document.querySelectorAll('[data-sec]'));
    function show(view) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-view') === view;
        t.classList.toggle('on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      secs.forEach(function (el) {
        var list = (el.getAttribute('data-sec') || '').split(/\s+/);
        el.classList.toggle('vis', list.indexOf(view) !== -1);
      });
      /* Channel HOME is horizontal carousels (Josh measured a real channel); the Videos
         tab keeps the grid. Same nodes, different flow. */
      var grid = document.querySelector('.yt-grid');
      if (grid) grid.classList.toggle('home-mode', view === 'home');
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var v = t.getAttribute('data-view');
        history.replaceState(null, '', '#' + v);
        show(v);
      });
    });
    var start = (location.hash || '#home').slice(1);
    show(tabs.some(function (t) { return t.getAttribute('data-view') === start; }) ? start : 'home');

    /* Shorts sort. Real reordering of real nodes — Latest is publish order as rendered
       (studio output first), Oldest is that reversed. */
    var row = document.querySelector('.yt-shrow');
    document.querySelectorAll('.yt-shf [data-sort]').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('.yt-shf [data-sort]').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        if (!row) return;
        var kids = Array.prototype.slice.call(row.children);
        if (b.getAttribute('data-sort') === 'oldest') kids.reverse();
        kids.forEach(function (k) { row.appendChild(k); });
      });
    });
  })();

  document.getElementById('yt-like').addEventListener('click', function () {
    var b = this;
    if (b.classList.contains('on')) return;
    b.classList.add('on');
    /* One like per video per browser, remembered — same discipline as subscribe: the +1 on
       screen is optimistic feedback for this press; the server tally is the truth on reload.
       Also write it back onto the card so switching videos and back keeps the number. */
    try { localStorage.setItem(likedKey(curVid), '1'); } catch (e) {}
    var n = parseInt(lks.textContent, 10);
    if (!isNaN(n)) lks.textContent = n + 1;
    var card = document.querySelector('.yt-card[data-vid="' + curVid + '"]');
    if (card && !isNaN(n)) card.setAttribute('data-likes', n + 1);
    toast('Liked. The Machine felt that.');
    beacon('wctv_like');
    if (curVid) beacon('tv_l_' + curVid);
  });

  document.getElementById('yt-share').addEventListener('click', function () {
    try { navigator.clipboard.writeText(window.location.href); toast('Link copied.'); }
    catch (e) { toast('Copy it from the address bar.'); }
  });

  /* THE HEADER COUNT MUST MATCH WHAT YOU CAN COUNT ON THE PAGE.
     The Liquid count is only the approved wc_skit ledger; the channel also carries films that
     live in the theme as real files. A visitor who reads one number and then counts another has
     caught the site in a wrong number, which is the same failure as inventing one.

     Shorts are counted too. They used to be excluded as "not long-form uploads", but that undercut
     the count by every short on the channel — and a real YouTube channel header counts its Shorts.
     Those are also precisely the films that go out on TikTok, YouTube and Instagram, so leaving
     them out made the site claim a smaller catalogue than it actually publishes.

     Deduped by video id where there is one and by source URL otherwise: the fixed theme shorts
     carry no data-vid, so an id-only tally would silently skip them. */
  (function () {
    var el = document.getElementById('yt-vidn');
    if (!el) return;
    var seen = {}, n = 0;
    [].forEach.call(document.querySelectorAll('.yt-card[data-vid], .yt-short'), function (c) {
      var v = c.getAttribute('data-vid') || c.getAttribute('data-src');
      if (v && !seen[v]) { seen[v] = 1; n++; }
    });
    if (!n) return;
    el.textContent = n;
    var word = el.nextSibling;
    if (word && word.nodeType === 3)
      word.nodeValue = word.nodeValue.replace(/videos?/, n === 1 ? 'video' : 'videos');
  })();

  /* ============ Immersive Shorts feed — real YouTube Shorts UI ============ */
  var shorts = [].slice.call(document.querySelectorAll('.yt-short')).map(function (el) {
    var t = el.getAttribute('data-title') || 'Weirdcastle TV';
    var m = t.match(/№\s*0*(\d+)/);
    return {
      src: el.getAttribute('data-src'),
      title: t,
      dur: el.getAttribute('data-dur') || '',
      /* Every short gets a stable id so its plays/likes/dislikes are ITS OWN record
         (tv_v_/tv_l_/tv_d_) — the raw material of the studio feedback loop (#78). */
      vid: el.getAttribute('data-vid') || (m ? 'spot' + m[1] : null)
    };
  });

  var shf = document.getElementById('shf');
  var feed = document.getElementById('shf-feed');
  var upBtn = document.getElementById('shf-up'), downBtn = document.getElementById('shf-down');
  var chLogo = document.querySelector('.yt-chav img');
  var logoSrc = chLogo ? chLogo.getAttribute('src') : '';
  var AUTH = shf.getAttribute('data-auth') === '1';
  var MYNAME = shf.getAttribute('data-name') || 'You';
  var MYCID = shf.getAttribute('data-cid') || '';
  var muted = false, curReel = 0;

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function hash(s){ var h=0; for(var i=0;i<s.length;i++){ h=(h*31+s.charCodeAt(i))|0; } return Math.abs(h); }
  /* No like numbers in the reel. There is no per-short telemetry, and the old likeCount()
     here literally manufactured one (views × 0.11) — the exact class of invented figure this
     site keeps deleting. Icon only until a short has a real count to show. */

  var CMTS = [
    ['Q','This sold me a hat I did not know I needed.'],
    ['R','the building is really just posting through it huh'],
    ['M','why is this the most honest ad on the internet'],
    ['J','bought it. no regrets. slight regrets. no regrets.'],
    ['D','the machine understood the assignment'],
    ['K','i was not going to enlist and then i was'],
    ['B','0:10 of pure institutional confidence'],
    ['T','showed my wife this. she has questions. i have a hat.'],
    ['S','the algorithm sent me and i am not mad about it'],
    ['P','this is what they took from us'],
    ['A','no notes. terrifying. buying two.'],
    ['V','i work in advertising and i am unwell']
  ];

  // Real SVG icons (no emoji) — YouTube-style, monochrome, currentColor.
  var IC = {
    like: '<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/></svg>',
    dislike: '<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"/></svg>',
    cmt: '<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4z"/></svg>',
    share: '<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M14 9V5l7 7-7 7v-4.1c-5 0-8.5 1.6-11 5.1 1-5 4-10 11-11z"/></svg>',
    shop: '<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2z"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="58" height="58" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>',
    vol: '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/></svg>',
    mute: '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73 4.27 3zM12 4L9.91 6.09 12 8.18V4zm7 8c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71z"/></svg>',
    music: '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/></svg>'
  };

  // Build one reel per short
  var reels = shorts.map(function (s, i) {
    var r = document.createElement('div');
    r.className = 'reel paused';
    r.setAttribute('data-i', i);
    r.innerHTML =
      '<div class="reel-stage">' +
        '<video class="reel-v" loop playsinline preload="none" src="' + esc(s.src) + '"></video>' +
        '<button class="reel-mute" type="button" aria-label="Mute">' + IC.vol + '</button>' +
        '<div class="reel-play">' + IC.play + '</div>' +
        '<div class="reel-prog"><i></i></div>' +
        '<div class="reel-cap">' +
          '<div class="reel-ch"><span class="reel-av">' + (logoSrc ? '<img src="' + esc(logoSrc) + '" alt="" aria-hidden="true">' : 'C') + '</span>' +
            '<b>@weirdcastletv</b><button class="reel-sub" type="button">Subscribe</button></div>' +
          '<div class="reel-title">' + esc(s.title) + '</div>' +
          '<div class="reel-sound">' + IC.music + ' original sound — Weirdcastle TV</div>' +
        '</div>' +
        '<div class="reel-rail">' +
          /* The word, not a number. There is still no per-short like telemetry, so a count here
             would be invented — but an empty label beside four labelled buttons reads as broken
             rather than as restraint, and real Shorts shows "Like" when it has no count either. */
          '<button class="rr like" type="button"><span class="ic">' + IC.like + '</span><span class="n">Like</span></button>' +
          '<button class="rr dislike" type="button"><span class="ic">' + IC.dislike + '</span><span class="n">Dislike</span></button>' +
          '<button class="rr cmt" type="button"><span class="ic">' + IC.cmt + '</span><span class="n">Comments</span></button>' +
          '<button class="rr share" type="button"><span class="ic">' + IC.share + '</span><span class="n">Share</span></button>' +
          '<a class="rr shop" href="/collections/all-products"><span class="ic">' + IC.shop + '</span><span class="n">Shop</span></a>' +
          '<span class="rr-av">' + (logoSrc ? '<img src="' + esc(logoSrc) + '" alt="" aria-hidden="true">' : '') + '</span>' +
        '</div>' +
      '</div>';
    feed.appendChild(r);
    return r;
  });

  function vid(r){ return r.querySelector('.reel-v'); }
  function syncMute(){ document.querySelectorAll('.reel-mute').forEach(function(b){ b.innerHTML = muted ? IC.mute : IC.vol; }); }

  function playReel(r){
    reels.forEach(function(x){ if(x !== r){ var xv=vid(x); xv.pause(); x.classList.add('paused'); } });
    if (!r._viewed) { r._viewed = true; var sv = shorts[+r.getAttribute('data-i')]; if (sv && sv.vid) beacon('tv_v_' + sv.vid); }
    var v = vid(r); v.muted = muted;
    var p = v.play();
    if (p && p.catch) p.catch(function(){ muted = true; v.muted = true; syncMute(); v.play().catch(function(){}); });
    r.classList.remove('paused');
  }

  // Autoplay whichever reel is centered; pause the rest
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting && e.intersectionRatio >= 0.6){
        curReel = reels.indexOf(e.target);
        playReel(e.target);
        updateArrows();
      }
    });
  }, { root: feed, threshold: [0, 0.6, 1] });
  reels.forEach(function(r){ io.observe(r); });

  // Per-reel interactions
  reels.forEach(function(r){
    var v = vid(r), bar = r.querySelector('.reel-prog i');
    v.addEventListener('timeupdate', function(){ if(v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
    function toggle(){ if(v.paused){ v.play(); r.classList.remove('paused'); } else { v.pause(); r.classList.add('paused'); } }
    v.addEventListener('click', toggle);
    r.querySelector('.reel-play').addEventListener('click', toggle);
    r.querySelector('.reel-mute').addEventListener('click', function(e){ e.stopPropagation(); muted = !muted; v.muted = muted; syncMute(); });
    var sd = shorts[+r.getAttribute('data-i')] || {};
    var like = r.querySelector('.rr.like');
    like.addEventListener('click', function(){ like.classList.toggle('on');
      if(like.classList.contains('on')){ beacon('wctv_short_like'); if (sd.vid) beacon('tv_l_' + sd.vid); } });
    var dis = r.querySelector('.rr.dislike');
    dis.addEventListener('click', function(){ if (dis.classList.toggle('on') && sd.vid) beacon('tv_d_' + sd.vid); });
    r.querySelector('.rr.share').addEventListener('click', function(){
      try { navigator.clipboard.writeText(window.location.href); toast('Link copied.'); }
      catch(e){ toast('Copy it from the address bar.'); }
    });
    var sub = r.querySelector('.reel-sub');
    sub.addEventListener('click', function(){ var on = sub.classList.toggle('done'); sub.textContent = on ? 'Subscribed ✓' : 'Subscribe'; if(on){ toast('Subscribed to Weirdcastle TV.'); beacon('wctv_sub'); } });
    r.querySelector('.rr.cmt').addEventListener('click', function(){ openComments(reels.indexOf(r)); });
  });

  // Open / close the full-screen feed
  function scrollToReel(i){
    if(i < 0 || i >= reels.length) return;
    curReel = i; updateArrows();
    feed.style.scrollSnapType = 'none';               // mandatory snap fights a smooth programmatic scroll — lift it until the scroll settles
    var restore = function(){ feed.style.scrollSnapType = 'y mandatory'; feed.removeEventListener('scrollend', restore); clearTimeout(feed._snap); };
    feed.addEventListener('scrollend', restore);
    clearTimeout(feed._snap); feed._snap = setTimeout(restore, 900);   // fallback for browsers without scrollend
    feed.scrollTo({ top: i * feed.clientHeight, behavior: 'smooth' });
  }
  function updateArrows(){ upBtn.disabled = curReel <= 0; downBtn.disabled = curReel >= reels.length - 1; }

  /* Measure the video and hand its edges to CSS, so the close button and the up/down arrows
     sit against the stage instead of the far corners of the monitor. Measured rather than
     computed from the 9:16 ratio because .reel-stage is also clamped by max-width on narrow
     viewports, and a formula would be wrong exactly there. */
  function trackStage(){
    var st = reels[curReel] && reels[curReel].querySelector('.reel-stage');
    if (!st) return;
    var r = st.getBoundingClientRect();
    if (!r.width) return;
    /* Written as inline left values rather than through a custom property: the var() route
       measured correctly but never reached `left` on this page, and an inline declaration
       cannot be outranked by anything in the sheet. */
    var xb = document.getElementById('shf-x'), br = shf.querySelector('.shf-brand'),
        ud = shf.querySelector('.shf-updn');
    if (xb) xb.style.left = Math.round(r.left) + 'px';
    if (br) br.style.left = Math.round(r.left + 50) + 'px';
    if (ud) ud.style.left = Math.round(r.right + 14) + 'px';
  }
  window.addEventListener('resize', trackStage);

  function openFeed(i){
    shf.classList.add('on'); shf.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow = 'hidden';
    curReel = i;
    feed.scrollTop = i * feed.clientHeight;   // land on the tapped short
    trackStage();
    updateArrows();
    setTimeout(function(){ playReel(reels[i]); }, 60);
    beacon('wctv_short');
  }
  function closeFeed(){
    shf.classList.remove('on'); shf.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
    reels.forEach(function(r){ vid(r).pause(); r.classList.add('paused'); });
    closeComments();
  }
  document.querySelectorAll('.yt-short').forEach(function(el, i){ el.addEventListener('click', function(){ openFeed(i); }); });
  document.getElementById('shf-x').addEventListener('click', closeFeed);
  upBtn.addEventListener('click', function(){ scrollToReel(curReel - 1); });
  downBtn.addEventListener('click', function(){ scrollToReel(curReel + 1); });
  document.addEventListener('keydown', function(e){
    if (!shf.classList.contains('on')) return;
    if (e.key === 'Escape') closeFeed();
    else if (e.key === 'ArrowDown'){ e.preventDefault(); scrollToReel(curReel + 1); }
    else if (e.key === 'ArrowUp'){ e.preventDefault(); scrollToReel(curReel - 1); }
    else if (e.key === ' '){ e.preventDefault(); var v = vid(reels[curReel]); if(v.paused){ v.play(); reels[curReel].classList.remove('paused'); } else { v.pause(); reels[curReel].classList.add('paused'); } }
  });

  /* Comments sheet — real persistent comments (engine) layered over the in-character seed. */
  var sheet = document.getElementById('reel-cmts'), rcList = document.getElementById('rc-list'),
      rcComp = document.getElementById('rc-comp'), rcCount = document.getElementById('rc-count');
  function jokeRows(seed, n){
    var html = '';
    for (var k = 0; k < n; k++){
      var c = CMTS[(seed + k * 5) % CMTS.length];
      html += '<div class="rc-c"><span class="av">' + c[0] + '</span><div class="bd">' +
        '<div class="h">@viewer' + ((seed + k * 7) % 9000 + 1000) + ' · ' + (k + 1) + 'd</div>' + esc(c[1]) + '</div></div>';
    }
    return html;
  }
  function realRow(c){
    var WC = window.WCComments;
    return '<div class="rc-c"><span class="av">' + esc((c.name || '?').charAt(0).toUpperCase()) + '</span><div class="bd">' +
      '<div class="h">' + esc(c.name) + ' · ' + (WC ? WC.timeAgo(c.ts) : 'now') + '</div>' + esc(c.body) + '</div></div>';
  }
  function seedRows(vidId){
    var arr = SEEDS[vidId];
    if (!arr || !arr.length) return null;
    return arr.map(function(c){
      return '<div class="rc-c"><span class="av">' + esc((c.n || '?').charAt(0).toUpperCase()) + '</span><div class="bd">' +
        '<div class="h">@' + esc(c.n) + '</div>' + esc(c.b) + '</div></div>';
    }).join('');
  }
  function openComments(i){
    var s = shorts[i], seed = hash(s.title), n = 4 + seed % 5;
    var thread = 'short-' + s.title, WC = window.WCComments;
    /* This video's OWN seed comments (engine-written, unique per film); the shared
       joke pool only covers the legacy Spots that predate per-video seeding. */
    rcList.innerHTML = seedRows(s.vid) || jokeRows(seed, n);
    /* The count is the number of comments actually IN the sheet (seeds + real), not an
       invented figure — the old (40 + seed % 940) claimed hundreds while showing nine. */
    function syncCount(){ rcCount.textContent = rcList.children.length + ' Comments'; }
    syncCount();
    rcComp.innerHTML = AUTH
      ? '<input id="rc-in" placeholder="Add a comment…" maxlength="600" aria-label="Add a comment"><button class="btn" id="rc-send" type="button" disabled>Comment</button>'
      : '<div style="font-size:13px;color:#606060;flex:1;">Sign in to add your comment.</div><a class="btn" href="/account/login">Sign in</a>';
    if (AUTH){
      var inp = document.getElementById('rc-in'), snd = document.getElementById('rc-send');
      inp.addEventListener('input', function(){ snd.disabled = !inp.value.trim(); });
      snd.addEventListener('click', function(){
        var txt = inp.value.trim(); if(!txt) return;
        snd.disabled = true;
        if (WC){
          WC.post(thread, { name: MYNAME, body: txt, cid: MYCID }).then(function(r){
            if (r && r.ok && r.comment) rcList.insertAdjacentHTML('afterbegin', realRow(r.comment));
            inp.value = ''; beacon('wctv_comment'); syncCount();
          });
        } else {
          rcList.insertAdjacentHTML('afterbegin', realRow({ name: MYNAME, body: txt, ts: Date.now() }));
          inp.value = ''; beacon('wctv_comment');
        }
      });
    }
    sheet.classList.add('on');
    if (WC){ WC.load(thread, 'new').then(function(items){
      if (items && items.length) rcList.insertAdjacentHTML('afterbegin', items.map(realRow).join(''));
      syncCount();
    }); }
  }
  function closeComments(){ sheet.classList.remove('on'); }
  document.getElementById('rc-x').addEventListener('click', closeComments);


  /* ============ WATCH PAGE ROUTER — ?v=<id> ============ */
  (function () {
    var wid = new URLSearchParams(location.search).get('v');
    if (!wid) return;
    var card = document.querySelector('.yt-card[data-vid="' + CSS.escape(wid) + '"]');
    if (!card) { history.replaceState(null, '', location.pathname); return; }

    document.querySelector('.yt-wrap').hidden = true;
    var W = document.getElementById('yt-watch');
    W.hidden = false;
    var title = card.getAttribute('data-title') || '';
    document.title = title + ' - Weirdcastle TV';

    var wv = document.getElementById('w-video');
    wv.src = card.getAttribute('data-src');
    var wp = card.getAttribute('data-poster');
    if (wp) wv.setAttribute('poster', wp);
    document.getElementById('w-title').textContent = title;
    document.getElementById('w-stats').textContent = card.getAttribute('data-stats') || '';
    document.getElementById('w-dtext').textContent = card.getAttribute('data-desc') || '';
    document.getElementById('w-likes').textContent = card.getAttribute('data-likes') || '0';

    /* A view = playback actually started, once per load — the site-wide rule. */
    wv.addEventListener('play', function () {
      if (wv._counted) return;
      wv._counted = true;
      beacon('wctv_play'); beacon('tv_v_' + wid);
    });

    /* Like: real count, one per browser. Dislike: recorded for the studio (tv_d_<id>),
       toggles visually, count deliberately hidden — same as the real YouTube. */
    var wl = document.getElementById('w-like'), wln = document.getElementById('w-likes');
    try { if (localStorage.getItem(likedKey(wid)) === '1') wl.classList.add('on'); } catch (e) {}
    wl.addEventListener('click', function () {
      if (wl.classList.contains('on')) return;
      wl.classList.add('on');
      try { localStorage.setItem(likedKey(wid), '1'); } catch (e) {}
      var n = parseInt(wln.textContent, 10);
      if (!isNaN(n)) wln.textContent = n + 1;
      toast('Liked. The Machine felt that.');
      beacon('wctv_like'); beacon('tv_l_' + wid);
    });
    var wd = document.getElementById('w-dislike');
    try { if (localStorage.getItem('wc-tv-disliked-' + wid) === '1') wd.classList.add('on'); } catch (e) {}
    wd.addEventListener('click', function () {
      var on = wd.classList.toggle('on');
      try { localStorage.setItem('wc-tv-disliked-' + wid, on ? '1' : '0'); } catch (e) {}
      if (on) { toast('Noted. The Machine will take this personally.'); beacon('tv_d_' + wid); }
    });

    document.getElementById('w-share').addEventListener('click', function () {
      try { navigator.clipboard.writeText(location.href); toast('Link copied.'); }
      catch (e) { toast('Copy it from the address bar.'); }
    });

    /* Subscribe here = the channel Subscribe: same counter, same real-channel hop. */
    var wsub = document.getElementById('w-sub');
    try { if (localStorage.getItem(SUBKEY) === '1') { wsub.classList.add('done'); wsub.textContent = 'Subscribed ✓'; } } catch (e) {}
    wsub.addEventListener('click', function () {
      sub.click();
      wsub.classList.toggle('done', sub.classList.contains('done'));
      wsub.textContent = sub.classList.contains('done') ? 'Subscribed ✓' : 'Subscribe';
    });

    /* Up next: every other video, real thumbs and real stats. */
    var next = document.getElementById('w-next');
    document.querySelectorAll('.yt-card[data-vid]').forEach(function (c) {
      if (c.getAttribute('data-vid') === wid) return;
      var t = c.querySelector('.yt-thumb img');
      var dur = c.querySelector('.yt-dur');
      var el = document.createElement('a');
      el.className = 'nx';
      el.href = '/pages/wc-tv?v=' + encodeURIComponent(c.getAttribute('data-vid'));
      el.innerHTML = '<span class="th">' + (t ? '<img src="' + t.getAttribute('src') + '" alt="" loading="lazy">' : '') +
        (dur ? '<span class="d">' + dur.textContent + '</span>' : '') + '</span>' +
        '<span class="bd"><span class="t">' + esc(c.getAttribute('data-title') || '') + '</span>' +
        '<span class="m">Weirdcastle TV · ' + esc(c.getAttribute('data-stats') || '') + '</span></span>';
      next.appendChild(el);
    });

    /* Comments: the real thread for THIS video (tv-<id>), sortable, count = what is here. */
    var clist = document.getElementById('w-clist'), ccount = document.getElementById('w-cn');
    var wsort = 'new', thread = 'tv-' + wid;
    function whenWC(fn){ if (window.WCComments) return fn();
      var t = setInterval(function(){ if (window.WCComments){ clearInterval(t); fn(); } }, 120); }
    function smallLike(){ return IC.like.replace('width="24" height="24"', 'width="14" height="14"'); }
    var wseeds = SEEDS[wid] || [];
    function seedHTML() {
      /* The in-character audience (#77): unique to THIS video, rendered like comments,
         never voteable — they are not in the real store and a vote on fiction would
         invent a number. Real comments always sort above them. */
      return wseeds.map(function (c) {
        return '<div class="wcm"><span class="av">' + esc((c.n || '?').charAt(0).toUpperCase()) + '</span>' +
          '<div><div class="h">@' + esc(c.n) + '</div><div>' + esc(c.b) + '</div></div></div>';
      }).join('');
    }
    function renderC(items) {
      var WC = window.WCComments;
      var total = items.length + wseeds.length;
      ccount.textContent = total + ' Comment' + (total === 1 ? '' : 's');
      if (!items.length && !wseeds.length) { clist.innerHTML = '<div class="wcm" style="color:#606060;">No comments yet. Be the first. CHET is watching.</div>'; return; }
      clist.innerHTML = items.map(function (c) {
        return '<div class="wcm"><span class="av">' + esc((c.name || '?').charAt(0).toUpperCase()) + '</span>' +
          '<div><div class="h">' + esc(c.name || 'Viewer') + '<span>' + WC.timeAgo(c.ts) + '</span></div>' +
          '<div>' + esc(c.body) + '</div>' +
          '<button class="lk" type="button" data-cid="' + esc(String(c.id)) + '">' + smallLike() + (c.up || 0) + '</button></div></div>';
      }).join('') + seedHTML();
      clist.querySelectorAll('.lk').forEach(function (b) {
        b.addEventListener('click', function () {
          WC.vote(thread, b.getAttribute('data-cid')).then(function (j) {
            if (j && j.ok) b.innerHTML = smallLike() + j.up;
          });
        });
      });
    }
    function loadC(){ window.WCComments.load(thread, wsort).then(renderC); }
    whenWC(function () {
      loadC();
      document.querySelectorAll('[data-wsort]').forEach(function (b) {
        b.addEventListener('click', function () {
          document.querySelectorAll('[data-wsort]').forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on'); wsort = b.getAttribute('data-wsort'); loadC();
        });
      });
      var cin = document.getElementById('w-cin'), csend = document.getElementById('w-csend');
      if (cin) {
        cin.addEventListener('input', function () { csend.disabled = !cin.value.trim(); });
        csend.addEventListener('click', function () {
          var txt = cin.value.trim(); if (!txt) return;
          csend.disabled = true;
          window.WCComments.post(thread, { name: MYNAME, body: txt, cid: MYCID }).then(function (j) {
            if (j && j.ok) { cin.value = ''; loadC(); beacon('wctv_comment'); }
            csend.disabled = false;
          });
        });
      }
    });
  })();

  beacon('wctv_view');
})();
